"use client";

import useAuthWelcome from "@/hooks/web3/useAuthWelcome";
import React, { useMemo } from "react";

import LayoutAlertBarMessage, { type AlertBarStylingType } from "@/components/Layout/AlertBar/Message";

import useGetAdminConfig from "@/hooks/api/useGetAdminConfig";

export default function LayoutAlertBarWrapper() {
  useAuthWelcome();

  const { data: adminConfig } = useGetAdminConfig();

  const { text, type } = useMemo(
    () => ({
      text: adminConfig?.rawConfig.maintenance_period_text,
      type: (adminConfig?.rawConfig.maintenance_period_type ?? "default") as AlertBarStylingType,
    }),
    [adminConfig?.rawConfig.maintenance_period_text, adminConfig?.rawConfig.maintenance_period_type]
  );

  return text && <LayoutAlertBarMessage message={text} type={type} />;
}
